export default __webpack_public_path__ + "static/media/Resume.5fd3e72c.pdf";